module.exports = __webpack_public_path__ + "img/removeEmail.64ba5fc9.svg";